import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TransferContainerConfirmationModal',
  props: {
  sourceContainer: {
    type: String,
    required: true,
  },
  targetContainer: {
    type: String,
    required: true,
  },
  numberOfPackagesToMove: {
    type: Number,
    required: true,
  },
},
  emits: ["closeConfirmationModal", "submitAndCloseConfirmationModal"],
  setup(__props, { emit }: { emit: ({
  (e: 'closeConfirmationModal'): void;
  (e: 'submitAndCloseConfirmationModal'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





function closeModal(): void {
  emit("closeConfirmationModal");
}

function submitAndCloseModal(): void {
  emit("submitAndCloseConfirmationModal");
}

return { __sfc: true,emit, props, closeModal, submitAndCloseModal }
}

})